<template>
  <div class="businessOperations">
    <Header></Header>
     <!-- Scroll Spy -->
      <sctionsScroll :page-sections="pageSections"></sctionsScroll>
      <!-- Scroll Spy -->
    <div class="container">
        <section class="zainCountry" v-for="(country,index) in this.operations.country" :key="index" :id="index">
            <div class="section__heading">{{country.title}}</div>
            <statistics :data="country.statistics"></statistics>
            <p v-for="(text,index2) in country.contents" :key="index2" v-html="text">
                <!-- {{text}} -->
            </p>
            <financialPerformance :data="country.financial_performance"></financialPerformance>
            <financialPerformance v-if="country.financial_performance2" :data="country.financial_performance2"></financialPerformance>
            <kpi :data="country.kpi"></kpi>
            
        </section>
    </div>

  </div>
</template> 

<script>
import businessOpeations from '@/components/businessOperations/data/businessOpeations.json';
import financialPerformance from '@/components/businessOperations/table';
import sctionsScroll from "@/components/common/sectionsScroll.vue";
import kpi from '@/components/businessOperations/kpi';
import statistics from '@/components/businessOperations/statistics'
export default {
    components:{
        financialPerformance,
        kpi,
        statistics,
        sctionsScroll
    },
    data(){ 
        return{
            operations: businessOpeations,
            pageSections: [
        {
          title: "KUWAIT",
          title_ar: "الكويت",
          id: "0", 
          number: "01",
        },
        {
          title: "SAUDI ARABIA",
          title_ar:  "السعودية",
          id: "1",
          number: "02",
        },
        {
          title: "IRAQ",
          title_ar: "العراق ",
          id: "2",
          number: "03",
        },
        {
          title: "SUDAN",
          title_ar: "السودان",
          id: "3",
          number: "04",
        },
        {
          title: "JORDAN",
          title_ar: "الأردن",
          id: "4",
          number: "05",
        },
        {
          title: "BAHRAIN",
          title_ar: "البحرين",
          id: "5",
          number: "06",
        },
      ],
        }
    },
    created(){
        if(this.$i18n.locale=="en"){
            this.operations = this.operations.en;
            
        }
        else{
            this.operations = this.operations.ar;
            
        }
    }
    

}
</script>
<style lang="scss">
    [data-page="business-operations"]{
        overflow-x: hidden;
        scroll-padding-top: 90px;
        .verticalLabel{
            color:#414042;
        }
        .pageSections {
      .navbar{
        left:40px;
        @media screen and (max-width:1600px){
          left:22px;
        }
        .nav-item{
          a {
            margin:0 !important;
            span{
                padding:0;
            }
          }
        }
      }
    }
    &.ar {
      .pageSections {
        .navbar{
          right:40px;
          left:auto;
          @media screen and (max-width:1600px){
            right:22px;
            left:auto;

          }
          .nav-item{
            a {
              span{
                background:rgba($color: #fff, $alpha: .5);
                padding-top:3px;
                padding-bottom:3px;
              }
            }
          }
        }
      }
    }
    }
</style>
<style lang="scss" scoped>
/deep/{
    
    header{
        .menu {
            a{
                color:#000;
            }
            svg{
                fill:#000;
            }
        }
    }
}

.businessOperations{
    padding:100px 0 30px 0;
    p{
        color:#414042;
        @media screen and (max-width:767px){
            font-size:rem(15px);
        }
    }
    .section__heading{
        font-size:rem(60px);
        color:#8a8c8e;
        font-weight:900;
        text-transform:uppercase;
        margin-bottom:rem(30px);
        text-align:center;
        @media screen  and (max-width:1600px){
            font-size:rem(50px);
        }
        @media screen  and (max-width:991px){
            font-size:rem(35px);
        }
    }
    /deep/{
        .lowerCase{
            text-transform: lowercase !important;
        }
        .slick-slide{
            img{
               max-height: 60px;
                margin:auto;
                @media screen  and (max-width:767px){
                    max-height:45px;
                }
            }
            .row{
                >div{
                    text-align:center;
                     font-weight:900;
                    font-size:rem(25px);
                    color:#414042;
                    line-height:1.3;
                    text-transform:capitalize;
                    span{
                        font-size:rem(20px);
                        font-weight:700;
                        display:block;
                        margin-bottom:5px;
                    }
                }
                .icon{
                    margin-bottom:rem(20px);
                    
                }
            }
        }
    }
}
.ar {
    .businessOperations{
        p{
            line-height:1.5;
        }
        /deep/{
            
            .vue-circular-progress .percent_sign{
                direction: ltr;
                display: inline-block;
            }
            .vue-circular-progress .percent__dec{
                display:none !important;
            }
        }
    }
}
</style>